import React from 'react';
import './CellGroup.scss';

const CellGroup = ({children, type = 'info'}) => {
  return <div className={`cell_group cell_group--${type}`}>{children}</div>;
};

export default CellGroup;
